import React from 'react'
import { Sliders as DashboardIcon } from 'react-feather'
import { navItems as dashboardItems } from '../components/sidebar/dashboardItems'
import { DashboardBase, DashboardBaseProps } from './DashboardBase'
import useAuth from '../hooks/useAuth'

const Dashboard = ({ children }: { children?: React.JSX.Element }) => {
    const { user } = useAuth()
    let sidebarItems: DashboardBaseProps['dashboardItems'] = [...dashboardItems]

    if (user?.groups?.includes('superadmin')) {
        sidebarItems = [
            {
                title: 'Admin',
                titleI18n: 'site.nav.adminSection',
                pages: [
                    {
                        title: 'Admin',
                        titleI18n: 'site.nav.adminSection',
                        href: '/admin/dashboard',
                        icon: DashboardIcon,
                    },
                ],
            },
            ...sidebarItems,
        ]
    } else {
        const excludePages: string[] = [] // under development, not available for all users
        sidebarItems = sidebarItems.map((section) => ({
            ...section,
            pages: section.pages.filter((page) => !excludePages.includes(page.href)),
        }))
    }

    return <DashboardBase dashboardItems={sidebarItems}>{children}</DashboardBase>
}

export default Dashboard
